import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  id: "body",
  class: "basic"
}
const _hoisted_2 = { class: "page-header" }
const _hoisted_3 = { class: "width-wrap" }
const _hoisted_4 = { class: "width-wrap" }
const _hoisted_5 = { class: "page-content section" }
const _hoisted_6 = {
  key: 0,
  class: "form-messages"
}
const _hoisted_7 = {
  key: 0,
  class: "flashmessage flash-success"
}
const _hoisted_8 = {
  key: 1,
  class: "flashmessage flash-danger"
}
const _hoisted_9 = {
  key: 1,
  class: "form-body"
}
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = { for: "frm-registerForm_password" }
const _hoisted_12 = { class: "help" }
const _hoisted_13 = {
  key: 0,
  class: "form-error"
}
const _hoisted_14 = {
  key: 1,
  class: "form-error"
}
const _hoisted_15 = { for: "frm-registerForm_confirmPassword" }
const _hoisted_16 = { class: "help" }
const _hoisted_17 = {
  key: 0,
  class: "form-error"
}
const _hoisted_18 = {
  key: 1,
  class: "form-error"
}
const _hoisted_19 = { class: "button button--primary" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h1", null, _toDisplayString(_ctx.$t('ResetPassword.title')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("form", {
          id: "registration-form",
          class: "form",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.send && _ctx.send(...args)), ["prevent"])),
          autocomplete: "off"
        }, [
          (_ctx.showFormMessages)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                (_ctx.isSuccess)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createTextVNode(_toDisplayString(_ctx.$t('ResetPassword.success-message')) + " ", 1),
                      _createVNode(_component_router_link, { to: { name: 'Login' } }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('ResetPassword.success-link')), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.isError)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.$t('forms.required-fields')), 1))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.errors, (error, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: "flashmessage flash-danger"
                  }, _toDisplayString(error), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (!_ctx.isSuccess)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.password.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_11, _toDisplayString(_ctx.$t('ResetPassword.password')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.v$.form.password.$model) = $event)),
                      type: "password",
                      id: "frm-registerForm_password",
                      name: "password",
                      class: "form-control is-required"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.password.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('forms.min', { count: _ctx.v$.form.password.minLength.$params.min })), 1),
                    (_ctx.v$.form.password.$dirty && _ctx.v$.form.password.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.password.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.password.minLength.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(_ctx.$t('forms.min', { count: _ctx.v$.form.password.minLength.$params.min })), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(["form-field", { 'is-danger': _ctx.v$.form.confirmPassword.$error }])
                  }, [
                    _createElementVNode("label", _hoisted_15, _toDisplayString(_ctx.$t('ResetPassword.password')) + ":", 1),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.v$.form.confirmPassword.$model) = $event)),
                      type: "password",
                      id: "frm-registerForm_confirmPassword",
                      name: "confirmPassword",
                      class: "form-control is-required"
                    }, null, 512), [
                      [
                        _vModelText,
                        _ctx.v$.form.confirmPassword.$model,
                        void 0,
                        { trim: true }
                      ]
                    ]),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('ResetPassword.password-help-confirm')), 1),
                    (_ctx.v$.form.confirmPassword.$dirty && _ctx.v$.form.confirmPassword.$invalid)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          (_ctx.v$.form.confirmPassword.required.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_17, _toDisplayString(_ctx.$t('forms.required')), 1))
                            : _createCommentVNode("", true),
                          (_ctx.v$.form.confirmPassword.sameAsPassword.$invalid)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString(_ctx.$t('ResetPassword.password-mismatch')), 1))
                            : _createCommentVNode("", true)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 2)
                ]),
                _createElementVNode("button", _hoisted_19, _toDisplayString(_ctx.$t('forms.send')), 1)
              ]))
            : _createCommentVNode("", true)
        ], 32)
      ])
    ])
  ]))
}